/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class InfectedDateSize {
  /**
  * Date of the infected data
  */
  'date': Date;
  /**
  * Size of the infected data in bytes
  */
  'sizeBytes': number;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "date",
      "baseName": "date",
      "type": "Date",
      "format": "date-time"
    },
    {
      "name": "sizeBytes",
      "baseName": "sizeBytes",
      "type": "number",
      "format": "int64"
    }  ];

  static getAttributeTypeMap() {
    return InfectedDateSize.attributeTypeMap;
  }

  public constructor() {
  }
}

